module.exports = __webpack_public_path__ + "img/line.a3af9cbe.svg";